let config = {
  'title': '《爱情公寓》免费电影票放肆抢',
  'keywords': '爱情公寓，电影票',
  'description': 'QQ浏览器桌面版用户专属特权——QQ浏览器请你免费看《爱情公寓》大电影，海量电影票、观影红包放肆抢'
};

config.layout = require('@layout/single');

require('./index.css');

config.qbtop = [
  require('@tencent/pcqb-act-header')
];

config.qbheader = [];

config.qbbody = [
  require('@modules/lottery'),
  require('@modules/video_info_answer'),
  require('@modules/video_recommend')
];

config.qbfooter = [
  require('@tencent/pcqb-act-footer')
];

module.exports = config;



// WEBPACK FOOTER //
// ./pages/index/config.js